import React from "react";
import DashboardHero from "../../components/Shop/DashboardHero";

const ProfileSellerDashboard = () => {
  return <DashboardHero />;
};

export default ProfileSellerDashboard;

